import React from 'react';

interface CourseAccessDeniedProps {
  user: {
    name: string;
    email: string;
  };
  courseName: string;
  onSignOut: () => void;
  onReturnToCourses: () => void;
}

const CourseAccessDenied: React.FC<CourseAccessDeniedProps> = ({ 
  user, 
  courseName, 
  onSignOut, 
  onReturnToCourses 
}) => {
  return (
    <div style={{ 
      padding: '40px 20px', 
      maxWidth: '600px', 
      margin: '0 auto',
      textAlign: 'center'
    }}>
      {/* Header */}
      <div style={{ marginBottom: '30px' }}>
        <div style={{
          width: '80px',
          height: '80px',
          backgroundColor: '#fef2f2',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 20px',
          border: '2px solid #fecaca'
        }}>
          <span style={{ fontSize: '2rem', color: '#dc2626' }}>🚫</span>
        </div>
        <h1 style={{ 
          margin: '0 0 10px 0', 
          fontSize: '2rem', 
          color: '#1f2937',
          fontWeight: '700'
        }}>
          Access Denied
        </h1>
        <p style={{ 
          margin: 0, 
          color: '#6b7280', 
          fontSize: '1.1rem',
          lineHeight: '1.5'
        }}>
          You don't have access to this course
        </p>
      </div>

      {/* Course Info */}
      <div style={{
        backgroundColor: '#f9fafb',
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '30px'
      }}>
        <h3 style={{ 
          margin: '0 0 10px 0', 
          color: '#374151',
          fontSize: '1.1rem'
        }}>
          Course: {courseName}
        </h3>
        <p style={{ 
          margin: 0, 
          color: '#6b7280',
          fontSize: '0.9rem'
        }}>
          Your email ({user.email}) is not enrolled in this course.
        </p>
      </div>

      {/* User Info */}
      <div style={{
        backgroundColor: '#f0f9ff',
        border: '1px solid #bae6fd',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '30px'
      }}>
        <h4 style={{ 
          margin: '0 0 10px 0', 
          color: '#0c4a6e',
          fontSize: '1rem'
        }}>
          Hello, {user.name}!
        </h4>
        <p style={{ 
          margin: 0, 
          color: '#0369a1',
          fontSize: '0.9rem'
        }}>
          You may have access to other courses. Please check with your trainer 
          if you believe you should have access to this course.
        </p>
      </div>

      {/* Action Buttons */}
      <div style={{ 
        display: 'flex', 
        gap: '12px', 
        justifyContent: 'center',
        flexWrap: 'wrap'
      }}>
        <button 
          onClick={onReturnToCourses}
          style={{
            padding: '12px 24px',
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '500',
            transition: 'background-color 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#2563eb';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#3b82f6';
          }}
        >
          ← Return to Courses
        </button>
        
        <button 
          onClick={onSignOut}
          style={{
            padding: '12px 24px',
            backgroundColor: '#6b7280',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '500',
            transition: 'background-color 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#4b5563';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#6b7280';
          }}
        >
          Sign Out
        </button>
      </div>

      {/* Help Text */}
      <div style={{ 
        marginTop: '30px', 
        padding: '15px',
        backgroundColor: '#fefce8',
        border: '1px solid #fde047',
        borderRadius: '6px'
      }}>
        <p style={{ 
          margin: 0, 
          color: '#a16207', 
          fontSize: '14px',
          lineHeight: '1.4'
        }}>
          💡 <strong>Need help?</strong> Contact your course administrator to request access 
          or verify your enrollment status.
        </p>
      </div>
    </div>
  );
};

export default CourseAccessDenied;
